export default "__VITE_ASSET__33M9BI2Z__"